import {createSlice, createSelector, createAsyncThunk} from '@reduxjs/toolkit';

import {infoSnack, successSnack, errorSnack} from '../snackbar/snackbarSlice';
import { fetchProducts} from './productsSlice';

import axios from 'axios';
const baseURL = process.env.REACT_APP_API_URL


export const preSignedURLMedia = createAsyncThunk(
  'productImages/preSignedURLMedia',
  async (args, thunkAPI) => {
    const config = {
      headers: {
        Authorization: `Bearer ${args.token}`,
      },
    };
    try {
      //full options
      const response = await axios.post(
        `${baseURL}/v1/admin/pre_signed_url`,
        {
          objectName: args.image.name,
          objectType: 'image',
          objectContentType: args.contentType,
        },
        config
      );

      if (response.data.preSignedURL) {
        thunkAPI.dispatch(
          uploadMedia({
            id: args.id,
            token: args.token,
            image: args.image,
            url: response.data.preSignedURL,
            contentType: args.contentType,
            action: args.action,
            message: true,
          })
        );
      }
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              'Error creating pre-signed url for AWS upload'
          )
        );
      }
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

export const uploadMedia = createAsyncThunk(
  'productImages/uploadMedia',
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {
          // Authorization: `Bearer ${args.token}`,
          'Content-Type': args.contentType,
        },
        //
      };
      const response = await axios.put(`${args.url}`, args.image.file, config);
      if (response.status === 200) {
        thunkAPI.dispatch(
          createProductImage({
            token: args.token,
            image: {
              statusID: 1,
              title: args.image.title,
              altText: args.image.altText,
              objName: args.image.name,
              imgType: args.image.imgType ? args.image.imgType : 'catalog',
              link: null,
            },
            id: args.id,
          })
        );
      }
      thunkAPI.dispatch(successSnack(`Product ${args.action} successfully`));

      // thunkAPI.dispatch(fetchProductByID({token: args.token, id: args.id}));


      thunkAPI.dispatch(
        fetchProducts({token: args.token, query: '?limit=25'})
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              'Error uploading image to AWS'
          )
        );
      }
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

export const fetchProductImages = createAsyncThunk(
  'productImages/fetchProductImages',
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: {Authorization: `Bearer ${args.token}`},
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/products/${args.id}/images`,
        config
      );
      return await response.data;
    } catch (error) {
       if (error.message.includes('401')) {
        localStorage.removeItem('coreUser');
        localStorage.removeItem('coreToken');    thunkAPI.dispatch(
          infoSnack('Session expired, please log in again'
          )
        );
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              'Error fetching productImages list'
          )
        );
      }
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

export const fetchProductImageByID = createAsyncThunk(
  'productImages/fetchProductImageByID',
  async (args, thunkAPI) => {
    const config = {
      headers: {Authorization: `Bearer ${args.token}`},
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/products/${args.id}/images/${args.imageID}`,
        config
      );
      return await response.data;
    } catch (error) {
       if (error.message.includes('401')) {
        localStorage.removeItem('coreUser');
        localStorage.removeItem('coreToken');    thunkAPI.dispatch(
          infoSnack('Session expired, please log in again'
          )
        );
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              'Error fetching productImage data'
          )
        );
      }
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

export const deleteProductImage = createAsyncThunk(
  'productImages/deleteProductImage',
  async (args, thunkAPI) => {
    const config = {
      headers: {Authorization: `Bearer ${args.token}`},
    };
    try {
      //full options
      const response = await axios.delete(
        `${baseURL}/v1/admin/products/${args.id}/images/${args.imageID}`,
        config
      );
      // thunkAPI.dispatch(successSnack('Image deleted successfully'));
      return await response;
    } catch (error) {
       if (error.message.includes('401')) {
        localStorage.removeItem('coreUser');
        localStorage.removeItem('coreToken');    thunkAPI.dispatch(
          infoSnack('Session expired, please log in again'
          )
        );
      } else  if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              'Error deleting productImage'
          )
        );
      }
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

export const updateProductImage = createAsyncThunk(
  'productImages/updateProductImage',
  async (args, thunkAPI) => {
    const config = {
      headers: {Authorization: `Bearer ${args.token}`},
    };
    try {
      //full options
      const response = await axios.patch(
        `${baseURL}/v1/admin/products/${args.id}/images/${args.imageID}`,
        args.productImage,
        config
      );

      // thunkAPI.dispatch(
      //   fetchProductImageByID({
      //     token: args.token,
      //     id: args.id,
      //     imageID: args.imageID,
      //   })
      // );

      // thunkAPI.dispatch(
      //   fetchProductImages({token: args.token, query: '?limit=500'})
      // );

      // thunkAPI.dispatch(successSnack('ProductImage updated successfully'));

      return await response;
    } catch (error) {
       if (error.message.includes('401')) {
        localStorage.removeItem('coreUser');
        localStorage.removeItem('coreToken');    thunkAPI.dispatch(
          infoSnack('Session expired, please log in again'
          )
        );
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              'Error updating productImage'
          )
        );
      }
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

export const createProductImage = createAsyncThunk(
  'productImages/createProductImage',
  async (args, thunkAPI) => {
    const config = {
      headers: {Authorization: `Bearer ${args.token}`},
    };
    try {
      const response = await axios.post(
        `${baseURL}/v1/admin/products/${args.id}/images`,
        args.image,
        config
      );

      return await response;
    } catch (error) {
       if (error.message.includes('401')) {
        localStorage.removeItem('coreUser');
        localStorage.removeItem('coreToken');    thunkAPI.dispatch(
          infoSnack('Session expired, please log in again'
          )
        );
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              'Error creating productImage'
          )
        );
      }
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

const productImagesSlice = createSlice({
  name: 'productImages',
  initialState: {
    productImage: {},
    productImageList: [],
    loading: 'idle',
    message: '',
    error: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProductImages.pending, (state) => {
      state.productImageList = [];
      state.loading = 'loading';
    });
    builder.addCase(fetchProductImages.fulfilled, (state, {payload}) => {
      state.error = '';
      state.productImageList = payload;
      state.loading = 'loaded';
    });
    builder.addCase(fetchProductImages.rejected, (state, action) => {
      state.loading = 'error';
      state.error = action.error.message;
    });

    builder.addCase(fetchProductImageByID.pending, (state) => {
      // state.productImage = {};
      state.loading = 'loading';
    });
    builder.addCase(fetchProductImageByID.fulfilled, (state, {payload}) => {
      state.error = '';
      state.productImage = payload;
      state.loading = 'loaded';
    });
    builder.addCase(fetchProductImageByID.rejected, (state, action) => {
      state.loading = 'error';
      state.error = action.error.message;
    });
    builder.addCase(deleteProductImage.pending, (state) => {
      state.message = '';
      state.loading = 'loading';
    });
    builder.addCase(deleteProductImage.fulfilled, (state, {payload}) => {
      state.error = '';
      // state.message = payload;
      state.loading = 'loaded';
    });
    builder.addCase(deleteProductImage.rejected, (state, action) => {
      state.loading = 'error';
      state.error = action.error.message;
    });
    builder.addCase(updateProductImage.pending, (state) => {
      state.message = '';
      state.loading = 'loading';
    });
    builder.addCase(updateProductImage.fulfilled, (state, {payload}) => {
      state.error = '';
      // state.message = payload;
      state.loading = 'loaded';
    });
    builder.addCase(updateProductImage.rejected, (state, action) => {
      state.loading = 'error';
      state.error = action.error.message;
    });
    builder.addCase(createProductImage.pending, (state) => {
      state.message = '';
      state.loading = 'loading';
    });
    builder.addCase(createProductImage.fulfilled, (state, {payload}) => {
      state.error = '';
      // state.message = payload;
      state.loading = 'loaded';
    });
    builder.addCase(createProductImage.rejected, (state, action) => {
      state.loading = 'error';
      state.error = action.error.message;
    });
  },
});

export const selectProductImages = createSelector(
  (state) => ({
    productImages: state.productImages,
    productImageList: state.productImages.productImageList,
    loading: state.productImages.loading,
    error: state.productImages.error,
    productImage: state.productImages.productImage,
  }),
  (state) => state
);
export default productImagesSlice.reducer;
